import { render, staticRenderFns } from "./OptionDropdown.vue?vue&type=template&id=35b30215"
import script from "./OptionDropdown.vue?vue&type=script&lang=js"
export * from "./OptionDropdown.vue?vue&type=script&lang=js"
import style0 from "./OptionDropdown.vue?vue&type=style&index=0&id=35b30215&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports